const internals = {
  recaptchaKey: String(process.env.REACT_APP_SITE_KEY),
  apimKey: String(process.env.REACT_APP_APIM_KEY),
  stixUrl: String(process.env.REACT_APP_STIX_URL),
  firstAccessUrl: String(process.env.REACT_APP_FIRST_ACCESS_LINK),
  helpUrl: String(process.env.REACT_APP_HELP_URL),
};

Object.freeze(internals);

export { internals };
